module.exports = __webpack_public_path__ + "static/assets/header-beli.b41a1ead.jpg";